import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Textarea from 'sushiweb/InputTypes/Textarea';
import { P } from 'sushiweb/Typography/Text';
import { InputWrapper } from '../styles';

const StyledTextarea = styled(Textarea)`
  width: 100%;
  margin: 1.6rem 0;
`;

const TextareaContainer = ({ parameter, label, value, large, disabled }) => {
  return (
    <InputWrapper large={large}>
      <P>{parameter}</P>
      <StyledTextarea
        value={value}
        resize='none'
        innerWidth='100%'
        label={label}
        disabled={disabled}
      />
    </InputWrapper>
  );
};

TextareaContainer.propTypes = {
  parameter: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
  large: PropTypes.bool,
  disabled: PropTypes.bool,
};

TextareaContainer.defaultProps = {
  parameter: '',
  label: '',
  value: '',
  large: false,
  disabled: false,
};

export default TextareaContainer;
